import { useState, useEffect, useRef, createElement } from 'react';
import PropTypes from 'prop-types';
import { isElementVisible, on, off } from '@sparefoot/react-core/utils/dom';

let firstSpaPage = true;

const VIEWPORT_EVENTS = [
	'resize',
	'scroll',
	'touchstart',
	'touchmove',
	'touchend',
	'load',
];

export default function LazyHydrate({ children, id, noLazy }) {
	const [readyForHydration, setReadyForHydration] = useState(false);
	const wrapperRef = useRef(null);

	const ssrElement = globalThis.document?.getElementById(id);
	const shouldHydrate =
		!ssrElement || readyForHydration || !firstSpaPage || noLazy;
	const divProps = { id, ref: wrapperRef };

	if (shouldHydrate) {
		firstSpaPage = false;
	} else {
		divProps.dangerouslySetInnerHTML = {
			__html: ssrElement.innerHTML,
		};
	}

	// Listen for scroll/resize to detect when element enters viewport
	useEffect(() => {
		if (readyForHydration || noLazy || !firstSpaPage) {
			return;
		}

		const handleViewportChange = () => {
			if (wrapperRef.current && isElementVisible(wrapperRef.current, 1)) {
				setReadyForHydration(true);
			}
		};

		on(VIEWPORT_EVENTS, handleViewportChange);
		// Check immediately in case already visible
		handleViewportChange();

		return () => {
			off(VIEWPORT_EVENTS, handleViewportChange);
		};
	}, [readyForHydration, noLazy, id]);

	return createElement('div', divProps, shouldHydrate ? children : undefined);
}

LazyHydrate.propTypes = {
	children: PropTypes.node,
	id: PropTypes.string,
	noLazy: PropTypes.bool,
};
